import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';

// 导入导航链接数据，确保底部分类与头部导航保持一致
const categoryLinks = {
  'zh-CN': [
    { name: '动作', path: '/category/动作' },
    { name: '益智', path: '/category/益智' },
    { name: '策略', path: '/category/策略' },
    { name: '体育', path: '/category/体育' },
    { name: '休闲', path: '/category/休闲' },
    { name: '多人', path: '/category/多人' },
    { name: '教育', path: '/category/教育' },
    { name: '角色扮演', path: '/category/角色扮演' },
  ],
  'en-US': [
    { name: 'Action', path: '/category/Action' },
    { name: 'Puzzle', path: '/category/Puzzle' },
    { name: 'Strategy', path: '/category/Strategy' },
    { name: 'Sports', path: '/category/Sports' },
    { name: 'Casual', path: '/category/Casual' },
    { name: 'Multiplayer', path: '/category/Multiplayer' },
    { name: 'Educational', path: '/category/Educational' },
    { name: 'RPG', path: '/category/RPG' },
  ]
};

const Footer = () => {
  const { language } = useContext(LanguageContext);
  
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-gray-300 pt-10 pb-6 px-4">
      <div className="container mx-auto">
        {/* 页脚顶部区域 */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* 关于我们 */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">
              {language === 'zh-CN' ? '关于我们' : 'About Us'}
            </h3>
            <p className="text-sm leading-relaxed mb-4 max-w-xs">
              {language === 'zh-CN' 
                ? '顶尖小是一个集合多种类型的在线平台，致力于为玩家提供优质的体验。'
                : 'Top Mini Games is an online platform that brings together various types of games, dedicated to providing players with a premium gaming experience.'}
            </p>
            <div className="flex space-x-3">
              <button className="text-white hover:text-blue-400 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd"></path>
                </svg>
              </button>
              <button className="text-white hover:text-blue-400 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
                </svg>
              </button>
              <button className="text-white hover:text-blue-400 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd"></path>
                </svg>
              </button>
            </div>
          </div>
          
          {/* 游戏分类 */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">
              {language === 'zh-CN' ? '游戏分类' : 'Game Categories'}
            </h3>
            <div className="flex flex-col flex-wrap h-40 gap-y-2 pr-0 max-w-[180px]">
              <Link 
                to="/" 
                className="text-sm text-gray-300 hover:text-blue-400 transition-colors pr-3 w-16"
              >
                {language === 'zh-CN' ? '全部' : 'All'}
              </Link>
              {categoryLinks[language].map((link, index) => (
                <Link 
                  key={index} 
                  to={link.path} 
                  className="text-sm text-gray-300 hover:text-blue-400 transition-colors pr-3 w-20"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
          
          {/* 快速链接 */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">
              {language === 'zh-CN' ? '快速链接' : 'Quick Links'}
            </h3>
            <div className="grid grid-cols-1 gap-y-2">
              <button className="text-sm text-gray-300 hover:text-blue-400 transition-colors text-left w-fit">
                {language === 'zh-CN' ? '常见问题' : 'FAQ'}
              </button>
              <button className="text-sm text-gray-300 hover:text-blue-400 transition-colors text-left w-fit">
                {language === 'zh-CN' ? '隐私政策' : 'Privacy Policy'}
              </button>
              <button className="text-sm text-gray-300 hover:text-blue-400 transition-colors text-left w-fit">
                {language === 'zh-CN' ? '使用条款' : 'Terms of Use'}
              </button>
              <button className="text-sm text-gray-300 hover:text-blue-400 transition-colors text-left w-fit">
                {language === 'zh-CN' ? '联系我们' : 'Contact Us'}
              </button>
            </div>
          </div>
          
          {/* 联系方式 */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">
              {language === 'zh-CN' ? '联系方式' : 'Contact Us'}
            </h3>
            <div className="flex items-start">
              <svg className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
              <span className="text-sm">18758883519@proton.me</span>
            </div>
          </div>
        </div>
        
        {/* 页脚底部版权信息 */}
        <div className="pt-6 border-t border-gray-800 text-center text-sm">
          <p>
            {language === 'zh-CN' 
              ? `© ${currentYear} 顶尖小游戏 版权所有`
              : `© ${currentYear} Top Mini Games. All Rights Reserved`}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 